import { BrowserRouter as Router } from "react-router-dom";
import Home from "./pages/Home";
import Header from "./pages/HeaderSection/Header";
import About from "./pages/AboutSection/About";
import Services from "./pages/ServicesSection/Services";
import Footer from "./pages/FooterSection/Footer";
import ContactCards from "./pages/ContactCards/ContactCards";
import Stats from "./pages/Stats/Stats";
import WhyChoose from "./pages/WhyChoose/WhyChoose";
import GetInTouch from "./pages/GetInTouch/GetInTouch";
import AppointmentBooking from "./pages/AppointmentBooking/AppointmentBooking";

function App() {
  return (
    <Router>
      <Header />
      <main>
        <Home id="home" />
        <ContactCards />
        <About id="about" />
        <Services id="services" />
        <Stats />
        <WhyChoose id="whyChooseUs" />
        <AppointmentBooking id="AppointmentBooking" />
        <GetInTouch id="GetInTouch" />
      </main>
      <Footer />
    </Router>
  );
}

export default App;
